import { httpRequest } from '@calendly/http-tools'

import { Cookies } from 'services/cookies'

export const eventService = {
  dispatch: async ({ name, version, dependencies, entities, properties, url = '/api/booking/analytics/track' }) => {
    const cookies = new Cookies()
    const anonymousId = cookies.getCookie('ajs_anonymous_id')
    const calAnonymousId = cookies.getCookie('cal_anonymous_id') || null
    if (calAnonymousId != null) {
      properties.cal_anonymous_id = calAnonymousId
    }

    const [success, response] = await httpRequest({
      url,
      method: 'POST',
      data: {
        name,
        version,
        anonymous_id: anonymousId,
        dependencies,
        entities,
        properties
      }
    })

    if (!success && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'review')) {
      alert(`Dispatching ${name} failed.\n\n${response?.payload?.message}`)
    }
  }
}
